import View from '@/base/views/view';

class CustomHealth extends View {
    
    static table = 'customhealth';

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        const customerField = res.fields.find(f => f.name === 'CustomId')
        if (customerField) {
            customerField.label = 'Customer'
            customerField.relation = 'customer'
            customerField.optionLabels = 'Name'
            customerField.editor = 'vue-select'
            customerField.filters = (r) => {return r.Project.Name == 'Nubbo'}
        }
        res.canAdd = true;
        return res;
    }

}

export default CustomHealth;